import React from 'react';

import Viewer from '../components/viewer';
import { CustomFormParts, Themes } from '../utils/types';
import GenericHotspot from '../components/hotspots/generic-hotspot';
import { HotspotTypes, posterExtraButton } from '../utils/types';
import { videoEmbedGenerator, galleryGenerator, posterGenerator, customFormGenerator } from '../utils/hotspot-data-generators';
import { openLiveChat } from '../utils/live-chat';

export default function Home(props) {
  return (
    <Viewer theme={Themes.Blaire} >

      <GenericHotspot
        yaw={-1.1959918660347655}
        pitch={0.07580395810538668}
        title="Welcome"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel1.png',
          extraWide: true,
          extraButtons: [
            posterExtraButton("Email alan.greenwood@sse.com", "mailto:alan.greenwood@sse.com"),
          ]
        })}
      />

      <GenericHotspot
        yaw={0.019769703281273365}
        pitch={-0.02627856372395776}
        title="Live Q&A details"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/whiteboard.png',
          zoomPan: false,
        })}
      />

      <GenericHotspot
        yaw={-0.046927245950757452}
        pitch={0.28389376705612705}
        title="Contact us / Feedback"
        type={HotspotTypes.CustomForm}
        data={customFormGenerator({
          title: "Contact us / Feedback",
          action: 'https://submit-form.com/jxrDIiti',
          method: 'POST',
          partsConfig: [
            CustomFormParts.radioChoice('How did you find the quality of information provided at today’s event?', 'How did you find the quality of information provided at today’s event?', ['Excellent', 'Good', 'Average', 'Poor'], true),
            CustomFormParts.radioChoice('Did you find the virtual exhibition accessible and easy to navigate?', 'Did you find the virtual exhibition accessible and easy to navigate?', ['Yes', 'No'], true),
            CustomFormParts.textarea('If no, what could we do better?', 'If no, what could we do better?'),
            CustomFormParts.radioChoice('Do you agree with SSE Renewables proposals for the Bhlaraidh Extension', 'Do you agree with SSE Renewables proposals for the Bhlaraidh Extension', ['Agree', 'Disagree', 'Unsure'], true),
            CustomFormParts.input('Would you like kept informed of project updates? If so, please confirm your e-mail address', 'email', 'Would you like kept informed of project updates? If so, please confirm your e-mail address'),
            CustomFormParts.textarea('Do you have any specific concerns regarding the proposals you would like the project team to consider?', "Do you have any specific concerns regarding the proposals you would like the project team to consider?"),
            CustomFormParts.para('Contact Us'),
            CustomFormParts.para("If you have any additional comments, feedback or would like to get in touch with the project team then please email alan.greenwood@sse.com or call Alan Greenwood on 07342 142714.")
          ],
        })}
      />

      <GenericHotspot
        yaw={0.59703057718441542}
        pitch={0.056777147547136337}
        title="Meet the Team"
        type={HotspotTypes.Gallery}
        data={galleryGenerator({
          modalStyle: { width: 'calc(60vh * (800/1000) + 20px)', padding: '10px' },
          images: [
            'images/team/jane.jpg',
            'images/team/alan.jpg',
            'images/team/carolyn.jpg',
            'images/team/craig.jpg',
          ],
          markdownCaptions: [
            <>
              <p>
                <b>Jane MacDonald</b> <br />
                I joined the Bhlaraidh Extension project as consent manager in October 2019 and I’m responsible for coordinating the design and development of the project. This includes working with our team of external consultants and specialists to deliver the environmental impact assessment report and the submission of the Section 36 application.
              </p>
            </>,
            <>
              <p>
                <b>Alan Greenwood</b> <br />
                I am Stakeholder Engagement Manager for the Bhlaraidh Extension wind farm and act as first point of contact for members of the community who would like to discuss the development. I’m here to assist with any inquiries members of the community may have about Bhlaraidh Extension and also support other SSE Renewables projects in the Great Glen. I’ve been with SSE Renewables since October 2020.
              </p>
            </>,
            <>
              <p>
                <b>Carolyn Wilson</b> <br />
                As Onshore Development Consents Team Manager, I acted as interim consent manager on Bhlaraidh Extension from May to November 2020. This involved ensuring onsite surveys took place safely within the relevant COVID restrictions and undertaking the first public exhibition for the project, which was held online. We have a new consent manager but I still take an interest in Bhlaraidh Extension’s development.
              </p>
            </>,
            <>
              <p>
                <b>Craig Cunningham</b> <br />
                I am the Development Project Manager for the Bhlaraidh Extension project, responsible for the project’s business case and managing the programme, budget and scope. I’ve been with SSE Renewables since January 2019 and taken the project through The Highland Council Pre-Application process and the Energy Consents Unit’s Scoping process as well as internal SSE Renewables governance milestones.
              </p>
            </>,
          ],
        })}
      />

      {/* <GenericHotspot
        yaw={1.3095985099137378}
        pitch={0.026777147547136337}
        title="Fly-through Videos"
        type={HotspotTypes.VideoEmbed}
        data={videoEmbedGenerator("https://vimeo.com/475965039/cb33b17ed9")}
      /> */}

      <GenericHotspot
        yaw={-0.6660526620683533}
        pitch={0.10618127534272404}
        title="Talk to us"
        onClick={openLiveChat}
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/live-chat-preview.png',
          zoomPan: false,
        })}
      />

      <GenericHotspot
        yaw={-1.4838622177225956}
        pitch={0.08180469584124044}
        title="Who we are"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel2.png',
          extraWide: true,
        })}
      />

      <GenericHotspot
        yaw={-1.7576783753782028}
        pitch={0.08180060934409481}
        title="The Great Glen"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel3.png',
          extraWide: true,
          // pdfLink: 'pdfs/panel2-detail.pdf',
          // linkText: 'View boundary map in detail (PDF)'
        })}
      />

      <GenericHotspot
        yaw={-2.0281287446997986}
        pitch={0.08180894719960448}
        title="The project"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel4.png',
          extraWide: true,
        })}
      />

      <GenericHotspot
        yaw={-2.2411574466854424}
        pitch={0.07680802997085542}
        title="Timeline"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel5.png',
          extraWide: true,
          // pdfLink: 'pdfs/panel4a-detail.pdf',
          // linkText: 'View offshore environmental designations in detail (PDF)'
        })}
      />

      

      {/* <GenericHotspot
        yaw={-2.297495165622511}
        pitch={0.0669126564939716}
        title="Onshore site"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel4b.png',
          extraWide: true,
          pdfLink: 'pdfs/panel4b-detail.pdf',
          linkText: 'View onshore key environmental constraints in detail (PDF)'
        })}
      /> */}

      <GenericHotspot
        yaw={-2.683635194234776}
        pitch={0.06691339316444201}
        title="Transport route"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel6.png',
          extraWide: true,
        })}
      />

      <GenericHotspot
        yaw={-3.002216446174799}
        pitch={0.06696019204613131}
        title="Environmental"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel7.png',
          extraWide: true,
        })}
      />

      <GenericHotspot
        yaw={-3.3403626167469787}
        pitch={0.06678108465987214}
        title="Communities"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel8.png',
          extraWide: true,
          extraButtons: [
            posterExtraButton("Email marianne.townsley@sse.com", "mailto:marianne.townsley@sse.com"),
            posterExtraButton("Read the Economic Impact Assessment", " https://www.sserenewables.com/media/5s4im3bp/volume-4-technical-appendix-141-economic-assessment-of-sse-projects-in-the-great-glen.pdf"),
          ]
        })}
      />

      <GenericHotspot
        yaw={2.32974133800624}
        pitch={0.06699838383926439}
        title="Viewpoints Map"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/viewpoints-map.jpg',
          extraWide: true
        })}
      />

      <GenericHotspot
        yaw={2.5455902563480697}
        pitch={0.05526642210339631}
        title="Viewpoint Renders"
        type={HotspotTypes.Gallery}
        data={galleryGenerator({
          modalStyle: { maxHeight: 'calc(90vw * (1539/1800))', maxWidth: '72vw' },
          images: [
            'images/pop-ups/viewpoint-2.jpg',
            'images/pop-ups/viewpoint-3.jpg',
            'images/pop-ups/viewpoint-5.jpg',
            'images/pop-ups/viewpoint-10.jpg',
            'images/pop-ups/viewpoint-17.jpg',
          ]
        })}
      />

      {/* <GenericHotspot
        yaw={2.9320453080627125}
        pitch={0.06654605117335244}
        title="Opportunities"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel9a.png',
          extraWide: true,
        })}
      /> */}

      {/* <GenericHotspot
        yaw={2.7214582442018354}
        pitch={0.05865050001903896}
        title="Next steps"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel9b.png',
          extraWide: true,
        })}
      /> */}

    </Viewer>
  );
}